export interface NoDatesServiceEntry {
	type: string;
	qty: number;
	rate: number;
	isTaxable: boolean;
	description?: string;
	pendingName?: string;
	needsInput?: boolean;
	forcedItemLabel?: string;
	_key?: string;
}

export type ParsedSegment = { date?: string; qty?: number; price?: number; label?: string; forcedItemLabel?: string };

function extractQuotedDescription(label?: string): string | undefined {
	const trimmed = label?.trim();
	if (!trimmed) return undefined;
	const match = trimmed.match(/^"(.+?)"$/) || trimmed.match(/^'(.*?)'$/);
	return match ? (match[1] || match[2] || '').trim() : undefined;
}

export function buildNoDatesServicesForCustomer(
	customerRows: any[],
	serviceColumns: string[],
	monthIso: string,
	parseSemicolonCell: (raw: string, inheritDate?: string) => ParsedSegment[],
	generateKey: () => string
): NoDatesServiceEntry[] {
	const normalizeKey = (label: string) => label.trim().toLowerCase().replace(/\s+/g, ' ');
	const labelCounts = new Map<string, { key: string; display: string; qty: number }>();
	const explicitEntries: NoDatesServiceEntry[] = [];

	customerRows.forEach(sourceRow => {
		serviceColumns.forEach(sc => {
			const rawCell = sourceRow?.[sc];
			const cell = String(rawCell || '').trim();
			if (!cell) return;
			const segments = parseSemicolonCell(cell, monthIso);
			for (const seg of segments) {
				if (seg.forcedItemLabel && seg.forcedItemLabel.trim()) {
					const forced = seg.forcedItemLabel.trim();
					const qty = seg.qty || 1;
					const rate = typeof seg.price === 'number' ? seg.price : 0;
					explicitEntries.push({ type: '', qty, rate, isTaxable: true, pendingName: forced, forcedItemLabel: forced, description: extractQuotedDescription(seg.label), needsInput: true, _key: generateKey() });
					continue;
				}
				if (seg.label && seg.label.trim()) {
					const lbl = seg.label.trim();
					const quotedDescription = extractQuotedDescription(lbl);
					if (quotedDescription !== undefined) {
						explicitEntries.push({ type: '', qty: seg.qty || 1, rate: typeof seg.price === 'number' ? seg.price : 0, isTaxable: true, description: quotedDescription, needsInput: true, _key: generateKey() });
						continue;
					}
					const key = normalizeKey(lbl);
					if (!key) continue;
					const existing = labelCounts.get(key);
					const addQty = seg.qty || 1;
					if (existing) {
						existing.qty += addQty;
					} else {
						labelCounts.set(key, { key, display: lbl, qty: addQty });
					}
					continue;
				}
				// price-only segments ignored by default in no-dates mode
			}
		});
	});

	const aggregatedServices: NoDatesServiceEntry[] = Array.from(labelCounts.values()).map(({ display, qty }) => ({ type: '', qty, rate: 0, isTaxable: true, pendingName: display, needsInput: true, _key: generateKey() }));
	return [...aggregatedServices, ...explicitEntries];
} 
